import React from 'react';

/**
 * Малюнки кроків «Як ми працюємо».
 *
 * Той самий прийом, що й у ServiceGlyph, SituationGlyph та AdvantageGlyph:
 * лінійні малюнки просто в розмітці, колір із тексту. П'ять кроків —
 * п'ять малюнків: розмова, аудит, обсяг і умови, робота, після результату.
 */
const Frame = ({ children, className }) => (
  <svg
    viewBox="0 0 64 64"
    className={className}
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    {children}
  </svg>
);

// 01. Розмова — дві репліки.
const Talk = () => (
  <>
    <path d="M8 12h30a4 4 0 0 1 4 4v14a4 4 0 0 1-4 4H22l-9 8v-8H8a4 4 0 0 1-4-4V16a4 4 0 0 1 4-4Z" />
    <path d="M48 26h8a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4h-3v7l-8-7H30a4 4 0 0 1-4-4v-2" />
    <path d="M14 22h18M14 28h10" />
  </>
);

// 02. Аудит того, що є — лупа над документом.
const Audit = () => (
  <>
    <path d="M14 6h22l8 8v18" />
    <path d="M36 6v8h8" />
    <path d="M14 6v50h20" />
    <path d="M20 22h14M20 30h10M20 38h8" />
    <circle cx="44" cy="44" r="9" />
    <path d="m51 51 7 7" />
  </>
);

// 03. Обсяг і умови — перелік із позначками й підпис.
const Scope = () => (
  <>
    <rect x="10" y="8" width="44" height="48" rx="4" />
    <path d="m18 20 3 3 6-6M18 32l3 3 6-6M18 44l3 3 6-6" />
    <path d="M32 19h14M32 31h14M32 43h8" />
  </>
);

// 04. Робота — шестерня в русі.
const Work = () => (
  <>
    <circle cx="32" cy="32" r="8" />
    <path d="M32 6v8M32 50v8M6 32h8M50 32h8M13.6 13.6l5.7 5.7M44.7 44.7l5.7 5.7M13.6 50.4l5.7-5.7M44.7 19.3l5.7-5.7" />
    <circle cx="32" cy="32" r="18" />
  </>
);

// 05. Після результату — календар із позначкою: ліцензія — це стан, не подія.
const After = () => (
  <>
    <rect x="8" y="12" width="48" height="44" rx="4" />
    <path d="M8 24h48M20 6v10M44 6v10" />
    <path d="m24 40 6 6 12-12" />
  </>
);

const GLYPHS = [Talk, Audit, Scope, Work, After];

const StepGlyph = ({ index, className = 'w-8 h-8' }) => {
  const Glyph = GLYPHS[index] || GLYPHS[0];
  return (
    <Frame className={className}>
      <Glyph />
    </Frame>
  );
};

export default StepGlyph;
